import { supabase } from '../config/supabase';

// Session management utility
class SessionManager {
  constructor() {
    this.setupVisibilityListener();
  }

  // Check if user wants persistent session
  isPersistentSession() {
    const sessionType = localStorage.getItem('ibv-session-type');
    return sessionType === 'persistent';
  }

  // Clear session if not persistent and browser was closed
  async checkSessionValidity() {
    const sessionType = localStorage.getItem('ibv-session-type');
    
    // If no session type is set, allow login (default persistent behavior)
    if (!sessionType) {
      return true;
    }
    
    // If session type is "session" (not persistent), always allow for now
    // Supabase handles its own session expiry
    sessionStorage.setItem('ibv-was-active', 'true');
    return true;
  }

  // Clear session data
  async clearSession() {
    try {
      await supabase.auth.signOut();
      localStorage.removeItem('ibv-session-type');
      sessionStorage.removeItem('ibv-was-active');
    } catch (error) {
      console.error('Error clearing session:', error);
    }
  }

  // Setup listener for page visibility to refresh token when user returns
  setupVisibilityListener() {
    document.addEventListener('visibilitychange', async () => {
      if (!document.hidden) {
        const { data: { session } } = await supabase.auth.getSession();
        if (session) {
          // Refresh the session
          await supabase.auth.refreshSession();
        }
      }
    });
  }

  // Logout function
  async logout() {
    await this.clearSession();
  }
}

export const sessionManager = new SessionManager();
